<template>
    <div v-if="show"
        class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center"
        @click.self="$emit('close')">
        <div class="relative mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
            <div class="mt-3 text-center">
                <h3 class="text-lg leading-6 font-medium text-gray-900">{{ title }}</h3>
                <div class="mt-4 px-7 py-3 text-left">
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="modal-input">
                        {{ label }}
                    </label>
                    <input type="text" id="modal-input" v-model="inputValue"
                        class="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        :placeholder="`Masukkan ${label}...`" @keyup.enter="save">
                </div>
                <div class="mt-6 flex justify-end space-x-3">
                    <button @click="save" id="ok-btn"
                        class="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300">
                        Save
                    </button>
                    <button @click="$emit('close')"
                        class="mt-2 px-4 py-2 bg-gray-200 text-gray-800 text-base font-medium rounded-md w-full shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddModal',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            default: 'Add New Item'
        },
        // === BAGIAN YANG DIPERBAIKI ===
        // Menambahkan prop 'label' untuk menerima data dari induk
        label: {
            type: String,
            default: 'New Value'
        }
        // === AKHIR BAGIAN YANG DIPERBAIKI ===
    },
    data() {
        return {
            inputValue: ''
        };
    },
    methods: {
        save() {
            if (this.inputValue.trim()) {
                this.$emit('save', this.inputValue.trim());
                this.inputValue = ''; // Reset setelah save
            } else {
                alert('Input tidak boleh kosong!');
            }
        }
    },
    watch: {
        show(newVal) {
            if (!newVal) {
                this.inputValue = ''; // Reset input saat modal ditutup
            }
        }
    }
}
</script>